export const dropdownOptions = [
    { name: 'SKF ADD', value: 'SKF_ADD' },
    { name: 'SKF EXIT', value: 'SKF_EXIT' },
    { name: 'KNORR ADD', value: 'KNORR_ADD' },
    { name: 'KNORR EXIT', value: 'KNORR_EXIT' }
];
